export default __webpack_public_path__ + "static/media/white-plus.6275e95d.svg";